module.exports = __webpack_public_path__ + "media/images/icon/add-black-f637e567f258caa88744e66e8ec93c2d.png";